var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavigationInbox = function SvgNavigationInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 3a1 1 0 0 0-.982.809l-1.75 9A1 1 0 0 0 3 13v6c0 1.093.907 2 2 2h14c1.093 0 2-.907 2-2v-6a1 1 0 0 0-.018-.191l-1.75-9A1 1 0 0 0 18.25 3H5.75Zm.824 2h10.852l1.555 8H15a1 1 0 0 0-.895.553L13.383 15h-2.766l-.722-1.447A1 1 0 0 0 9 13H5.02l1.554-8ZM5 15h3.383l.722 1.447A1 1 0 0 0 10 17h4a1 1 0 0 0 .895-.553L15.617 15H19v4H5v-4Z"
  })));
};
export default SvgNavigationInbox;